import Phaser from 'phaser';
import { getTextStyle } from '../scripts/FontConfig.js';

export default class CreditsScene extends Phaser.Scene {
  constructor() {
    super('CreditsScene');
  }
  createSceneTransitionIn() {
    // Use Phaser's native camera fade in
    this.cameras.main.fadeIn(300, 0, 0, 0);
  }
   createSceneTransitionOut(callback) {
    // Use Phaser's native camera fade out
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.on('camerafadeoutcomplete', (camera) => {
      callback();
    });
  }

  create() {

    this.createSceneTransitionIn();

    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Background
    
    // Background
    // this.add.rectangle(width / 2, height / 2, width, height, 0x2c3e50);
    this.add.image(width / 2, height / 2, 'creditsScreen').setOrigin(0.5);
       
    // Back button
    const backButton = this.add.text(width / 2 - 280, height / 2 - 200, '⬅️ Hoofdmenu', getTextStyle({
      fontSize: '24px',
      fill: '#9b59b6',
      fontWeight: 'bold'
    })).setOrigin(0.5);
    
    backButton.setInteractive({ useHandCursor: true });
    backButton.on('pointerover', () => {
      backButton.setStyle({ fill: '#bb8fce' });
    });
    backButton.on('pointerout', () => {
      backButton.setStyle({ fill: '#9b59b6' });
    });
    backButton.on('pointerdown', () => {
      this.nextScene();
    });
    
    // ESC key to go back
    this.input.keyboard.on('keydown-ESC', () => {
      this.nextScene();
    });
  }
  nextScene() {
    this.createSceneTransitionOut(() => {
      this.scene.start('StartScene');
    });
  }

}